export const processComplianceDataUtils = (complianceData) => {
  let totalYes = 0;
  let totalNo = 0;
  let totalUnknown = 0;
  let latestDate = null;

  if (!complianceData || complianceData.length === 0) {
    return {
      processedData: [],
      headerData: {
        overallYesPercentage: 0,
        overallNoPercentage: 0,
        overallUnknownPercentage: 0,
        lastUpdate: null,
      },
    };
  }

  const processedData = complianceData.map((item, index) => {
    let sectionCounts = {yes: 0, no: 0, unknown: 0 }
    if (item.sections && item.sections.length > 0) {
      sectionCounts = item.sections.reduce(
        (acc, section) => {
          if (section.compliant === "Yes") acc.yes++;
          else if (section.compliant === "No") acc.no++;
          else if (section.compliant === "Unknown") acc.unknown++;
          return acc;
        },
        { yes: 0, no: 0, unknown: 0 }
      );
    }

    const total =
      sectionCounts.yes + sectionCounts.no + sectionCounts.unknown;
    const yesPercentage = (sectionCounts.yes / total) * 100;
    const noPercentage = (sectionCounts.no / total) * 100;
    const unknownPercentage = (sectionCounts.unknown / total) * 100;

    // Update overall counts
    totalYes += sectionCounts.yes;
    totalNo += sectionCounts.no;
    totalUnknown += sectionCounts.unknown;

    // Update latest date
    const currentDate = new Date(item.assessmentDate);
    if (!latestDate || currentDate > new Date(latestDate)) {
      latestDate = item.assessmentDate;
    }

    const maxCount = Math.max(
      sectionCounts.yes,
      sectionCounts.no,
      sectionCounts.unknown
    );
    let status = "success";
    if (sectionCounts.no > 0) {
      status = "error";
    } else if (sectionCounts.unknown > 0) {
      status = "warning";
    }

    return {
      id: item.id,
      title: item.sectionDescription,
      date: item.assessmentDate,
      hasAlert: item.hasAlert,
      status,
      pieChartData: total > 0 ? [
        {
          data: [
            {
              id: 0,
              type: "Yes",
              value: yesPercentage,
              label: `Yes: ${yesPercentage.toFixed(1)}%`,
            },
            {
              id: 1,
              type: "No",
              value: noPercentage,
              label: `No: ${noPercentage.toFixed(1)}%`,
            },
            {
              id: 2,
              type: "Unknown",
              value: unknownPercentage,
              label: `Unknown: ${unknownPercentage.toFixed(1)}%`,
            },
          ],
        },
      ] : null,
      color: ["#14b8a6", "#e93123", "#A9A9A9"],
    };
  });

  // Calculate overall percentages
  const overallTotal = totalYes + totalNo + totalUnknown;
  const overallYesPercentage = (totalYes / overallTotal) * 100;
  const overallNoPercentage = (totalNo / overallTotal) * 100;
  const overallUnknownPercentage = (totalUnknown / overallTotal) * 100;

  const headerData = {
    overallYesPercentage,
    overallNoPercentage,
    overallUnknownPercentage,
    lastUpdate: latestDate,
  };

  return { processedData, headerData };
};